/**
 * 检查是否支持 localStorage 与  sessionStorage
 * @return {boolean}
 */
export const isStorageSupported = (() => {
  if (!('localStorage' in window)) return false

  // 兼容隐身模式
  try {
    const testKey = 'test'
    const session = window.sessionStorage
    const local = window.localStorage

    local.setItem(testKey, '1')
    session.setItem(testKey, '1')
    local.removeItem(testKey)
    session.removeItem(testKey)

    return !!local && !!session
  } catch (error) {
    return false
  }
})()

/**
 * 获取 localStorage 的值
 * @param {string} key localStorage key name
 */
export const getLocalStorage = (key) => {
  if (isStorageSupported) return window.localStorage.getItem(key)
  return null
}

/**
 * 设置 localStorage 的值
 * @param {string} key localStorage key name
 * @param {string} value 值
 */
export const setLocalStorage = (key, value) => {
  if (isStorageSupported) window.localStorage.setItem(key, value)
}

/**
 * 移除 localStorage
 * @param {string} key localStorage key name
 */
export const removeLocalStorage = (key) => {
  if (isStorageSupported) window.localStorage.removeItem(key)
}

/**
 * 获取 sessionStorage 的值
 * @param {string} key sessionStorage key name
 */
export const getSessionStorage = (key) => {
  if (isStorageSupported) return window.sessionStorage.getItem(key)
  return null
}

/**
 * 设置 sessionStorage 的值
 * @param {string} key sessionStorage key name
 * @param {string} value 值
 */
export const setSessionStorage = (key, value) => {
  if (isStorageSupported) window.sessionStorage.setItem(key, value)
}

/**
 * 移除 sessionStorage
 * @param {string} key sessionStorage key name
 */
export const removeSessionStorage = (key) => {
  if (isStorageSupported) window.sessionStorage.removeItem(key)
}
